wbApp.directive('wbSearchFilter', [
    function () {
        return {
            restrict: 'A',
            scope: {
                filterOptions: '='
            },
            template: '<div class="input-group">' +
                      '    <span class="input-group-btn">' +
                      '        <button class="btn btn-default" type="button"' +
                      '                ng-model="filterOptions.showFilterRow"' +
                      '                bs-checkbox>' +
                      '            <i class="fa fa-search"></i>' +
                      '        </button>' +
                      '    </span>' +
                      '    <input type="text"' +
                      '           class="form-control"' +
                      '           ng-model-options="{ debounce: 700 }"' +
                      '           ng-model="filterOptions.filterText"' +
                      '           placeholder="{{\'TXT_SEARCH\' | translate}}">' +
                      '</div>'
        }
    }
]);

wbApp.directive('wbSearchFilter2', [
    function () {
        return {
            restrict: 'A',
            scope: {
                filterOptions: '=',
                searchText: '='
            },
            template: '<div class="input-group">' +
                      '    <span class="input-group-btn">' +
                      '        <button class="btn btn-default" type="button"' +
                      '                ng-model="filterOptions.visible"' +
                      '                bs-checkbox>' +
                      '            <i class="fa fa-search"></i>' +
                      '        </button>' +
                      '    </span>' +
                      '    <input type="text"' +
                      '           class="form-control"' +
                      '           ng-model-options="{ debounce: 700 }"' +
                      '           ng-model="searchText.text"' +
                      '           placeholder="{{\'TXT_SEARCH\' | translate}}">' +
                      '</div>'
        }
    }
]);